import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { Modal } from "react-bootstrap";
import Spinner from "../../../reusables/spinner";
import {
  animationValues,
  transitionValues,
} from "../../../../utils/pageTransitions";
import InputField from "../../../reusables/input";
import {
  allocate_order,
  fetch_selectedSuppliers,
} from "../../../../redux/actions/adminActions";
import Pagination from "../../../reusables/pagination";
import { get_orders_by_customer } from "../../../../redux/actions/adminActions";
import OrderDetails from "../../orders/orderDetails";
import Dropdown from "../../../reusables/dropdown";
import { order_status, periods, user_order_status } from "../../../../utils/options";

function Orders({
  accessToken,
  getOrders,
  orders,
  selectedSuppliers,
  selected,
}) {
  const [loading, setLoading] = useState(true);
  const token = accessToken;
  let params = {};
  let status = "processing";

  const success = () => {
    setLoading(false);
  };

  const [filteredOrder, setOrders] = useState([]);

  const [optionsActive, setOptions] = useState(null);

  const [orderDetails, setOrder] = useState(false);

  const [selectedOrder, setSelect] = useState([]);

  const [allocate, setAllocate] = useState(false);

  const [active, setActive] = useState(0);

  const handleSelect = (id) => {
    setSelect(id);
    setOrder(true);
  };

  const [search, setSearch] = useState("");

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    let filter = Item;
    setLoading(true);
    params = { ...params, ...{ filter: Item } };
    getOrders({ token, selected, success, params });
  };

  const [hasFilter, setFilter] = useState(false);
  const [selectedStatus, setStatus] = useState("Status");
  const handleFilter = (status) => {
    setStatus(status);
    setLoading(true);
    params = { ...params, ...{ status: status } };
    getOrders({ token, selected, success, params });
  };

  const searchHandler = (e) => {
    if (search !== "") {
      const searchResults = orders.filter((i) => i.order_id == search);
      setOrders(searchResults);
      setFilter(true);
    } else {
      setFilter(false);
    }
  };

  useEffect(() => {
    setOrders(orders);
  }, [orders]);

  useEffect(() => {
    if (selected > 0) {
      setLoading(true);
      getOrders({ token, selected, success }); 
    }
  }, [selected]);

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getOrders({ token, selected, status, success, params });
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    setSearch(e.target.value)
    if (value == "") return;
    setLoading(true);
    params = { ...params, ...{ search: value } };
    getOrders({ token, selected, status, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween mobileBlock">
          <div className="searchHolder">
            <InputField
              name={search}
              iconClick={searchHandler}
              placeholder="Search by order ID"
              icon
              iconClass="ri-search-line"
              onChange={handleSearch}
            />
          </div>

          <div className="alignOnly pt-2">
            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
            <Dropdown value={selectedStatus} className="mx-1">
              <div
                className="isClickable hoverGreen"
                onClick={() => {
                  setStatus("All");
                  setFilter(false);
                }}
              >
                <p className="sectionText px-3 py-2 mb-0">All</p>
              </div>
              {user_order_status?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>

          {/* <div className="alignOnly pt-2">
                        <Dropdown value="All dates" className='mx-1' />
                        <Dropdown value="Status" className='mx-1' />
                    </div> */}
        </div>

        {loading ? (
          <Spinner big />
        ) : (
          <div className="sectionHeight--mid scrollable s pt-4">
            <table className="table table__custom">
              <thead className="sectionText--small textIsGray table__head pb-2">
                <tr className="">
                  <th className="">Order Number</th>
                  <th className="vAlign">Date</th>
                  <th className="vAlign">Total Products Cost</th>
                  <th className="vAlign">Total Handling Cost</th>
                  <th className="vAlign">Delivery Cost</th>
                  <th className="vAlign">Sub Total</th>
                  <th className="vAlign">Exch. Rate</th>
                  <th className="vAlign">Platform Fee</th>
                  <th className="vAlign">VAT</th>
                  <th className="vAlign">Profit Per Order</th>
                  <th className="vAlign">Customer</th>
                  <th className="vAlign">Allocated to</th>
                  <th className="vAlign">Status</th>
                  <th className="vAlign">Action</th>
                </tr>
              </thead>
              <tbody className="">
                {hasFilter
                  ? filteredOrder?.data?.map((order) => (
                      <tr className="hasRadius">
                        <td className="alignOnly pt-3">
                          <input
                            type="checkbox"
                            className="isClickable"
                            name=""
                            id=""
                          />

                          <p className="mb-0  sectionText mx-2">
                            #{order.sub_order_id}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">{order.date}</p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.items_total}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0 sectionText">
                            ₦{order.handling_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3 address">
                          <p className="mb-0 sectionText">
                            ₦{order.delivery_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.sub_total}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.exchange_rate}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.platform_fee}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">₦{order.vat}</p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.profit_per_order}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  textIsGreen sectionText">
                            {order.customer?.first_name}{" "}
                            {order.customer?.last_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  textIsGreen sectionText">
                            {order.allocated_to?.business_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p
                            className={`mb-0  tag ${
                              order.order_status === "Allocating"
                                ? "allocating"
                                : "done"
                            }`}
                          >
                            {order.order_status}{" "}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <i
                            class="ri-more-line isClickable"
                            onClick={
                              optionsActive === order.id
                                ? () => setOptions(null)
                                : () => setOptions(order.id)
                            }
                          ></i>

                          {optionsActive === order.id && (
                            <div className="options">
                              <div className="caret"></div>
                              <div className="p-2 textIsBold lAlign sectionText--small">
                                <div
                                  className="hasBorder--bottom pb-2"
                                  onClick={() => handleSelect(order.id)}
                                >
                                  Order Details
                                </div>
                                {/* <div
                                                            className="pt-2 pb-2 hasBorder--bottom"
                                                            onClick={ () => handleSelectSupplier(order.id) }>
                                                            Re-allocate
                                                        </div> */}
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  : orders?.data.map((order) => (
                      <tr className="hasRadius">
                        <td className="alignOnly pt-3">
                          <input
                            type="checkbox"
                            className="isClickable"
                            name=""
                            id=""
                          />

                          <p className="mb-0  sectionText mx-2">
                            #{order.sub_order_id}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">{order.date}</p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.items_total}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0 sectionText">
                            ₦{order.handling_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3 address">
                          <p className="mb-0 sectionText">
                            ₦{order.delivery_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.sub_total}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.exchange_rate}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.platform_fee}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">₦{order.vat}</p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.profit_per_order}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  textIsGreen sectionText">
                            {order.customer?.first_name}{" "}
                            {order.customer?.last_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  textIsGreen sectionText">
                            {order.allocated_to?.business_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p
                            className={`mb-0  tag ${
                              order.tx_status === "Delivered"
                                ? "done"
                                : (order.tx_status === "Pending") ? "allocating" : (order.tx_status == "Processing") ? "processing" : "pending"
                            }`}
                          >
                            {order.tx_status}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <i
                            class="ri-more-line isClickable"
                            onClick={
                              optionsActive === order.id
                                ? () => setOptions(null)
                                : () => setOptions(order.id)
                            }
                          ></i>

                          {optionsActive === order.id && (
                            <div className="options">
                              <div className="caret"></div>
                              <div className="p-2 textIsBold lAlign sectionText--small">
                                <div
                                  className="hasBorder--bottom pb-2"
                                  onClick={() => handleSelect(order.id)}
                                >
                                  Order Details
                                </div>
                                {/* <div
                                                            className="pt-2 pb-2 hasBorder--bottom"
                                                            onClick={ () => handleSelectSupplier(order.id) }>
                                                            Re-allocate
                                                        </div> */}
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="d-flex justify-content-end">
          <Pagination
            onChange={onPageChange}
            page={orders?.current_page}
            total={orders?.total}
            per_page={orders?.per_page}
          />
        </div>
      </div>

      <Modal show={orderDetails} onHide={() => setOrder(false)} centered>
        <div className="sectionHeight--mid py-3">
          <OrderDetails orderID={selectedOrder} allocated show_allocating={false}/>
        </div>
      </Modal>

      <Modal show={allocate} onHide={() => setAllocate(false)} centered>
        <div
          className="icon--tiny isClickable closeModal"
          onClick={() => setAllocate(false)}
        >
          <i class="ri-close-line sectionText--small"></i>
        </div>
        <div className="sectionHeight--mid alignOnly container py-3">
          {selectedSuppliers?.length > 0 ? (
            <div className="w-100 px-4 pt-3">
              {selectedSuppliers?.map((item) => (
                <div className="alignOnly pb-3">
                  <span
                    className={`checkbox ${active === item.id && "active"}`}
                    onClick={() => setActive(item.id)}
                  ></span>
                  <p className="sectionText--mid mb-0 mx-2">
                    {item.supplier?.business_name}
                  </p>
                </div>
              ))}

              <button
                className="btn__filled btn__long mt-3 mb-2"
                onClick={handleAllocate}
              >
                Allocate
              </button>
            </div>
          ) : (
            <div className="w-100">
              <div className="center mb-2">
                <Spinner />
              </div>
              <p className="sectionText--mid textIsGreen textIsBold vAlign">
                Loading Suppliers
              </p>
            </div>
          )}
        </div>
      </Modal>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  orders: state.admin.orders,
  selectedSuppliers: state.admin.selectedSuppliers,
});

const mapDispatchToProps = (dispatch) => ({
  getOrders: (token, status, success) =>
    dispatch(get_orders_by_customer(token, status, success)),
  getSelectedSuppliers: (id, token, success) =>
    dispatch(fetch_selectedSuppliers(id, token, success)),
  allocateOrder: (id, supplier_id, token, success) =>
    dispatch(allocate_order(id, supplier_id, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
